import {
  type PersonaListSnapshot,
  type PersonaListStateDeps,
  normalizeDesktopShowRows,
  peekExpectRestore,
  hasListSnapshot,
  clearListRestoreState,
  saveListSnapshot,
  parseListSnapshot,
  leavePersonaListState,
} from '../shared/list-state-storage.base';

export { type PersonaListTab as SchedulerListTab } from '../shared/list-state-storage.base';

export const SCHEDULER_LIST_SNAPSHOT_KEY = 'dgag_scheduler_list_snapshot';
export const SCHEDULER_EXPECT_RESTORE_KEY = 'dgag_scheduler_expect_restore';

export type SchedulerListSnapshot = PersonaListSnapshot;
export type LeaveSchedulerPersonaListStateDeps = PersonaListStateDeps;

export function normalizeSchedulerDesktopShowRows(size: number): number {
  return normalizeDesktopShowRows(size);
}

export function peekExpectSchedulerRestore(): boolean {
  return peekExpectRestore(SCHEDULER_EXPECT_RESTORE_KEY);
}

export function hasSchedulerListSnapshot(): boolean {
  return hasListSnapshot(SCHEDULER_LIST_SNAPSHOT_KEY);
}

export function clearSchedulerListRestoreState(): void {
  clearListRestoreState(SCHEDULER_LIST_SNAPSHOT_KEY, SCHEDULER_EXPECT_RESTORE_KEY);
}

export function saveSchedulerListSnapshot(snapshot: SchedulerListSnapshot): void {
  saveListSnapshot(SCHEDULER_LIST_SNAPSHOT_KEY, snapshot);
}

export function parseSchedulerListSnapshot(): SchedulerListSnapshot | null {
  return parseListSnapshot(SCHEDULER_LIST_SNAPSHOT_KEY);
}

export function leaveSchedulerPersonaListState(deps: LeaveSchedulerPersonaListStateDeps): void {
  leavePersonaListState(deps, SCHEDULER_LIST_SNAPSHOT_KEY, SCHEDULER_EXPECT_RESTORE_KEY, '/scheduler');
}
